import {AudioPlayer} from "./audioPlayer";
import {getEffectResourceUrl} from "./effectLib";

export const starAudioPlayer = new AudioPlayer()
starAudioPlayer.load(getEffectResourceUrl('celebrate.mp3'))

export const swipeAudioPlayer = new AudioPlayer()
swipeAudioPlayer.load(getEffectResourceUrl('swipe.mp3'))
